<script>
  import { onMount, afterUpdate } from 'svelte'
  import Header from '../Content/Header/Header.svelte'
  import Content from '../Content/Content.svelte'
  import Comments from '../Content/Comments/Comments.svelte'
  import TextButton from '../../components/TextButton.svelte'
  import Spinner from '../../components/Spinner.svelte'
  import ReviewMedia from '../../components/ReviewMedia'
  import MediaModal from '../../components/MediaModal'
  import CommentAndShareButton from '../Content/CommentAndShareButton.svelte'
  import { fetchQuestions } from '../../api'
  import { generateBgColor, getReviewerName } from '../../utils'
  import configModule from '../../config'

  export let questions
  export let settings
  export let totalQuestions
  let loading = false
  let nameColor
  let textColor
  let reviewerName
  let limit
  let remainingAnswers
  let remainingQuestions
  let currentAnswers
  let activeAnswersId
  let primaryColor
  let media = []
  let currentMediaQuestionId
  let mediaIndex = 0
  let textDirection
  let secondaryTextColor
  let profilePictureColor

  onMount(() => {
    primaryColor = settings.widget_settings.general_settings.primary_color
    nameColor =
      settings.widget_settings.general_settings.reviewer_name_text_color
    textColor = '#000000'
    limit = settings.widget_settings.product_review_form.reviews_per_page
    textDirection = settings.widget_settings.general_settings.text_direction
    secondaryTextColor = '#696c85'
    profilePictureColor =
      settings.widget_settings.general_settings.profile_picture_color
  })

  afterUpdate(() => {
    remainingQuestions = totalQuestions - questions.length
  })

  const toggleAnswers = (question, id) => {
    const answers = question.answers
    currentAnswers = answers
    currentAnswers = answers.slice(0, limit)
    remainingAnswers = question.answers.filter(x => !currentAnswers.includes(x))
    if (answers.length > 0) {
      activeAnswersId === id ? (activeAnswersId = null) : (activeAnswersId = id)
    }
  }

  const loadMore = async () => {
    loading = true
    const config = configModule()
    const businessId = config.aid
    const clientId = config.apiKey
    const lastItem = questions.slice(-1)[0]
    const questionsResponse = await fetchQuestions({
      businessId,
      clientId,
      limit,
      cursor: lastItem.id
    })
    const newQuestions = questions.concat(questionsResponse.data)
    questions = newQuestions
    loading = false
  }

  const loadMoreAnswers = async answers => {
    const chunk = await remainingAnswers.slice(0, limit)
    const newCurrentAnswers = currentAnswers.concat(chunk)
    remainingAnswers = answers.filter(x => !newCurrentAnswers.includes(x))
    currentAnswers = newCurrentAnswers
  }

  const handleMediaClick = event => {
    mediaIndex = event.detail.currentMedia.index
    media = event.detail.currentMedia.reviewMedia
    currentMediaQuestionId = event.detail.currentReviewId
  }

  const closeModal = () => {
    currentMediaQuestionId = null
    media = []
  }

  reviewerName = getReviewerName(settings)
</script>

<style>
  .content-dis {
    line-height: 1.5;
    font-size: 14px;
  }

  .question-list {
    border-bottom: 1px solid #edeff0;
  }

  .question-list .question-box {
    padding: 20px 20px 15px;
  }

  .question-header {
    display: flex;
  }

  .kb-question__pagination {
    text-align: center;
    margin: 20px 0;
    display: flex;
    justify-content: center;
  }

  .no-questions {
    border-bottom: none !important;
    text-align: center;
  }
</style>

<div class="$style.content-dis">
  {#if questions.length > 0}
    {#each questions as question (question.id)}
      <div class="$style.question-list">
        <div class="$style.question-box">
          <div class="$style.question-header">
            <Header
              reviewerName={question.owner.name}
              reviewerEmail={question.owner.email}
              {nameColor}
              profileBackground={generateBgColor()}
              date={question.created_at}
              dateFormat={settings.widget_settings.general_settings.date_format}
              {profilePictureColor}
              verifiedTextColor={secondaryTextColor} />
          </div>
          {#if question.media}
            <MediaModal
              {media}
              {closeModal}
              isActive={question.id === currentMediaQuestionId}
              {mediaIndex}>
              <ReviewMedia
                on:selectMedia={handleMediaClick}
                reviewId={question.id}
                style="direction: {textDirection};"
                reviewMedia={question.media} />
            </MediaModal>
          {/if}

          <Content
            message={question.text}
            readMoreTextColor={secondaryTextColor}
            readMoreText={settings.translations.read_more_text}
            readLessText={settings.translations.read_less_text}
            isQna={true}
            color={textColor}
            contentSize={settings.widget_settings.general_settings.content_font_size}
            titleSize={settings.widget_settings.general_settings.title_font_size}
            {textDirection} />
          <CommentAndShareButton
            comments={question.answers}
            toggleComments={() => toggleAnswers(question, question.id)}
            isQna={true}
            commentsText={settings.translations.answers_text}
            style="direction: {textDirection};"
            {secondaryTextColor} />
          {#if activeAnswersId === question.id}
            <Comments
              readMoreTextColor={secondaryTextColor}
              readMoreText={settings.translations.read_more_text}
              readLessText={settings.translations.read_less_text}
              comments={currentAnswers}
              currentId={activeAnswersId}
              {reviewerName}
              {profilePictureColor}
              {textColor}
              buttonTextColor={primaryColor}
              commentsId={question.id}
              {nameColor}
              loadComments={() => loadMoreAnswers(question.answers)}
              remainingComments={remainingAnswers}
              isQna={true}
              {textDirection} />
          {/if}
        </div>
      </div>
    {/each}
    {#if remainingQuestions > 0}
      <div class="$style.kb-question__pagination">
        {#if loading}
          <Spinner />
        {:else}
          <TextButton textColor={primaryColor} handleClick={loadMore}>
            {settings.translations.load_more_text}
          </TextButton>
        {/if}
      </div>
    {/if}
  {:else}
    <div class="$style.question-list $style.no-questions">
      <div class="$style.question-box">
        <h5 style="color: {textColor};">
          {settings.translations.neptune.be_the_first_to_ask_question_this_website_text}
        </h5>
      </div>
    </div>
  {/if}
</div>
